/* ═══════════════════════════════════════════════════════════════
 *  Resort OS — Production Debugging
 *  ═══════════════════════════════════════════════════════════════ */

function unregisterSW(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister()));
}

function tableLog(title: string, rows: [string, unknown][]) {
  const maxLen = Math.max(...rows.map(r => r[0].length));
  const sep = ' │ ';
  console.groupCollapsed(`%c[DEBUG] ${title}`, 'color:#2C3E2D;font-weight:bold');
  for (const [key, value] of rows) {
    console.log(`%c${key.padEnd(maxLen)}${sep}%c${value}`, 'color:#1565C0', 'color:#1A1A1A');
  }
  console.groupEnd();
}

function logBuildInfo(): void {
  tableLog('Build Info', [
    ['React', (window as any).React?.version || 'unknown'],
    ['Source Maps', 'ON'],
    ['Mode', import.meta.env.MODE],
    ['Built', new Date().toISOString()],
  ]);
}

function monitorFonts(): void {
  if (typeof document === 'undefined' || !('fonts' in document)) return;
  document.fonts.ready.then(() => {
    const rows: [string, unknown][] = [];
    document.fonts.forEach(f => {
      const icon = f.status === 'loaded' ? '✅' : f.status === 'error' ? '❌' : '⏳';
      rows.push([`${icon} ${f.family}`, `${f.weight} ${f.style}`]);
    });
    tableLog('Fonts', rows);

    const expected = ['', ''];
    for (const name of expected) {
      if (!document.fonts.check(`12px "${name}"`)) {
        console.warn(`[DEBUG] Font NOT available: "${name}"`);
      }
    }
  });
}

function captureGlobalErrors(): void {
  window.addEventListener('error', event => {
    console.groupCollapsed('%c[DEBUG] Global Error', 'color:#C62828;font-weight:bold');
    console.log('Message:', event.message);
    console.log('File:', event.filename, `line ${event.lineno}:${event.colno}`);
    console.log('Stack:', event.error?.stack || 'no stack');
    console.groupEnd();
  });

  window.addEventListener('unhandledrejection', event => {
    console.groupCollapsed('%c[DEBUG] Unhandled Rejection', 'color:#E65100;font-weight:bold');
    console.log('Reason:', event.reason?.message || event.reason);
    console.log('Stack:', event.reason?.stack || 'no stack');
    console.groupEnd();
  });
}

function trackFailedRequests(): void {
  const origFetch = window.fetch.bind(window);
  window.fetch = async (...args: Parameters<typeof fetch>) => {
    const start = performance.now();
    try {
      const res = await origFetch(...args);
      if (!res.ok && res.status >= 400) {
        console.warn(`[DEBUG] HTTP ${res.status}: ${args[0]} (${res.url})`);
      }
      return res;
    } catch (e) {
      console.error(`[DEBUG] Network failure: ${args[0]}`, e);
      throw e;
    }
  };
}

export function debugInit(): void {
  unregisterSW();
  logBuildInfo();
  monitorFonts();
  captureGlobalErrors();
  trackFailedRequests();
}
